import React, { useState, Fragment, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  CustomInput,
} from 'reactstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  postAPI_User_Images,
  postAPI_Bmb_Images,
} from '../../../../../../constants/APIs';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import classnames from 'classnames';
import Validation from '../../../../../../components/Validation';
export function UploadImagesForm({
  visible,
  toggleModal,
  formLabel,
  propertyId,
  bmb,
  parentLoadData,
  parentBmbData,
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const fileObj = [];
  const handleSubmit = () => {
    if (isAgree) {
      const data = new FormData();
      files.forEach((file) => {
        data.append('files', file.img);
        data.append('tags', file.tags);
        data.append('captions', file.caption);
      });

      if (!bmb) {
        data.append('propertyId', propertyId);
        data.append('groupId', getGroupID());
        data.append('folder', "");
      }
      else {
        data.append('type', "Bmb");
      }

      data.append('creator', 'dashboard');

    if (!bmb) {
        setApiState('processing');
        AxiosAPI({
          method: 'post',
          url: `${postAPI_User_Images}`,
          data: data,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(
          (res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
              && res.data.Messages !== null && res.data.Messages.length > 0) {
              setMsg(res.data.Messages);
              setOpen(true);
            }
            else {
              setApiState('success');
              toggleModal();
              parentLoadData();
            }
          },
          (error) => {
            setApiState('fail');
            console.log('eee.data', error.data);
          }
        );
      } else {
        setApiState('processing');
        AxiosAPI({
          method: 'post',
          url: `${postAPI_Bmb_Images}`,
          data: data,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(
          (res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
              && res.data.Messages !== null && res.data.Messages.length > 0) {
              setMsg(res.data.Messages);
              setOpen(true);
            }
            else {
              setApiState('success');
              toggleModal();
              parentBmbData();
            }
          },
          (error) => {
            setApiState('fail');
            console.log('eee.data', error.data);
          }
        );
      }
    } else {
      showErrorModal(true);
    }
  };
  const [files, setFiles] = useState([]);
  const [isAgree, setAgree] = useState(false);
  const [errorModal, showErrorModal] = useState(false);
  const [ApiState, setApiState] = useState('default');
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) =>
        fileObj.push({
          img: Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
          tags: [],
          caption: '',
        })
      );

      setFiles([...files, ...fileObj]);
    },
  });

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  const handleTagChange = (index, event) => {
    const values = [...files];
    values[index].tags = event;
    setFiles(values);
  };

  const handleChange = (index, event) => {
    const values = [...files];
    values[index].caption = event.target.value;
    setFiles(values);
  };

  const handleRemoveFields = (index) => {
    const values = [...files];
    values.splice(index, 1);
    setFiles(values);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <section className="container">
              <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <div class="dz-default dz-message">
                  <span>
                    Drop files here to upload, or click to select files
                  </span>
                  <p className="font-weight-medium mb-0 ">
                    <i className="demo-icon simple-icon-cursor-move"></i>
                  </p>
                </div>
              </div>
              <div
                className="filepicker dropzone-gallery dz-clickable dz-started"
                style={{ minHeight: '160px', border: '0px' }}
              >
                {files.map((file, index) => (
                  <div className="dz-preview dz-file-preview mb-3" key={index}>
                    <div className="row">
                      <div className="p-0 w-30 position-relative">
                        <div className="preview-container">
                          <img
                            data-dz-thumbnail
                            className="img-thumbnail border-0"
                            src={file.img.preview}
                            style={{ display: 'block' }}
                          />
                        </div>
                      </div>
                      <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                        <div>
                          {' '}
                          <span data-dz-name>{file.img.name}</span>{' '}
                        </div>
                        <div
                          className="text-primary text-extra-small"
                          data-dz-size
                        >
                          {file.img.size}
                        </div>
                      </div>
                      <TagsInput
                        value={file.tags}
                        onChange={(event) => handleTagChange(index, event)}
                      />
                      <Input
                        type="text"
                        name="caption"
                        placeHolder="Caption"
                        onChange={(event) => handleChange(index, event)}
                      />
                    </div>

                    <a
                      href="#/"
                      className="remove"
                      data-dz-remove
                      onClick={() => handleRemoveFields(index)}
                    >
                      {' '}
                      <i className="glyph-icon simple-icon-trash" />{' '}
                    </a>
                  </div>
                ))}
              </div>
            </section>
          </Row>
          <div className="row my-1 ml-0  font-weight-bold">
            <CustomInput
              type="checkbox"
              id="agree"
              value={isAgree}
              checked={isAgree}
              onChange={(e) => {
                setAgree(!isAgree);
              }}
            >
              <span className="mt-1" style={{ verticalAlign: 'middle' }}>
                I have copyright or permissions to use this image
              </span>
            </CustomInput>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleSubmit}
            className={`btn-multiple-state ${classnames({
              'show-spinner': ApiState === 'processing',
              'show-success': ApiState === 'success',
              'show-fail': ApiState === 'fail',
            })}`}
          >
            <span className="spinner d-inline-block">
              <span className="bounce1" />
              <span className="bounce2" />
              <span className="bounce3" />
            </span>
            <span className="icon success">
              <i className="simple-icon-check" />
            </span>
            <span className="icon fail">
              <i className="simple-icon-exclamation" />
            </span>
            <span className="label">Save</span>
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={errorModal} toggle={() => showErrorModal(!errorModal)}>
        <ModalHeader toggle={() => showErrorModal(!errorModal)}>
          {formLabel}
        </ModalHeader>
        <ModalBody>
          <div className="m-2">
            <h5>Please check the copyright or permissions check box</h5>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => showErrorModal(!errorModal)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
